import React from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import TvIcon from "@mui/icons-material/Tv";
import CampaignIcon from "@mui/icons-material/Campaign";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { colaSinNombre } from "./colas";

/**
 * Definiciones de columnas para el DataGrid de colas
 */

// Acción de fila: llama al callback con la fila completa sin propagar el clic
export const crearAccion = (key, label, icon, callback, row, disabled = false) => (
    <GridActionsCellItem
        key={key}
        icon={icon}
        label={label}
        disabled={disabled}
        color="inherit"
        onClick={(e) => {
            e.stopPropagation();
            callback(row);
        }}
    />
);

/**
 * Genera las columnas del DataGrid de colas
 * @param {Object} handlers - Callbacks de acciones de fila (reciben la fila completa)
 * @param {Function} handlers.onRegistro - Abre el registro de turnos de la cola
 * @param {Function} handlers.onPantalla - Abre la pantalla de turnos de la cola
 * @param {Function} handlers.onGestor - Abre el gestor de llamamientos de la cola
 * @param {Function} handlers.onEditar - Edita la cola
 * @param {Function} handlers.onEliminar - Elimina la cola
 * @returns {Array} Definiciones de columnas para el DataGrid
 */
export const generateColaColumns = ({ onRegistro, onPantalla, onGestor, onEditar, onEliminar }) => [
    { field: "id", headerName: "ID", flex: 0.5, editable: false },
    { field: "nombre", headerName: "Nombre", flex: 1, editable: false },
    {
        field: "actions",
        type: "actions",
        headerName: "",
        width: 220,
        getActions: ({ row }) => {
            const deshabilitada = colaSinNombre(row);
            return [
                crearAccion("registro", "Registro", <HowToRegIcon />, onRegistro, row, deshabilitada),
                crearAccion("pantalla", "Pantalla", <TvIcon />, onPantalla, row, deshabilitada),
                crearAccion("gestor", "Gestor", <CampaignIcon />, onGestor, row, deshabilitada),
                crearAccion("editar", "Editar", <EditIcon />, onEditar, row),
                crearAccion("eliminar", "Eliminar", <DeleteIcon />, onEliminar, row),
            ];
        },
    },
];
